import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from '@shopify/polaris'
import CustomModal from '../../CustomModal'
import UpsertExpForm from '../../UpsertExperienceForm'
import { updateExperience } from '../../../apis/experience'
import analytics, { MixPanelAnalytics } from '../../../utils/analytics'
import queryClient from '../../../utils/query'

export default function EditExpModal({ experience, open, setOpen }) {
  const { t } = useTranslation()

  const submitHandler = async (val) => {
    const res = await updateExperience(experience.id, {
      name: val.name,
      weight: parseInt(val.weightage),
      startTime: val.startTime,
      endTime: val.endTime,
      triggerKey: Boolean(val.key) ? val.key : null,
      triggerValue: Boolean(val.value) ? val.value : null,
    })
    setOpen(false)
    if (res.error) {
      return {
        error: res.error,
      }
    }
    analytics.trackExperienceEvent(MixPanelAnalytics.Actions.UPDATE, res.data.experience)
    await queryClient.invalidateQueries(['shopDetails'])
    shopify.toast.show(t('Section.List.expStatusSuccess'))
    return { error: null }
  }

  return (
    <CustomModal
      show={open}
      setShow={setOpen}
      title={t('ABExperience.editTitle')}
      variant="medium"
      maxHeight={'max-content'}
    >
      <div
        style={{
          width: '500px',
        }}
      >
        <Card>
          <UpsertExpForm
            submitHandler={submitHandler}
            currentValues={{
              name: experience.name,
              weight: experience.weight,
              startTime: experience.startTime,
              endTime: experience.endTime,
              triggerKey: experience.triggerKey,
              triggerValue: experience.triggerValue,
            }}
          />
        </Card>
      </div>
    </CustomModal>
  )
}